<template>
  <div v-if="reportData">
    <div v-for="(item, index) in reportData.part" :key="index" class="mb-3 border rounded">
      <!-- Part 標題 -->
      <div class="p-3 d-flex justify-content-between align-items-center drop mb-2"
        :class="{ 'bg-blue-lighter-toeic text-white': (index === selectedIndex), 'bg-white': (index !== selectedIndex) }"
        style="cursor: pointer"
      >
        <div class="w-100">
          <p class="mb-0 font-bold">Part {{ index + 1 }}</p>
          <p class="mb-0">{{ item.name }}</p>
        </div>
        <!-- <span>
          <i class="fas fa-chevron-up" v-if="index === selectedIndex"></i>
          <i class="fas fa-chevron-down" v-else></i>
        </span> -->
      </div>

      <!-- 子題 -->
      <div class="list-group list-group-flush">
        <button
          v-for="(question, qIndex) in item.data"
          :key="qIndex"
          class="child"
          :class="{ 'bg-blue-lighter-toeic text-white': (index === selectedIndex) && (qIndex === selectedIndex2) }"
          @click.stop="activateQuestion(index, qIndex)"
        >
          Question {{ qIndex + 1 }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    reportData: {
      type: Object
    }
  },
  data () {
    return {
      selectedIndex: 0,
      selectedIndex2: 0
    }
  },
  methods: {
    togglePart (index) {
      this.selectedIndex = index
      // this.selectedIndex2 = 0
      // this.parts[index].open = !this.parts[index].open
    },
    activateQuestion (index, qIndex) {
      this.selectedIndex = index
      this.selectedIndex2 = qIndex
      this.$emit('emitSelectedIndex', { index: index, qIndex: qIndex })
    }
  }
}
</script>
<style scoped lang="scss">
.child {
  color: #166CB3;
  border: 1px solid rgba(255, 255, 255, 0);
  border-left: 6px solid #166CB3;
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  margin-bottom: 2px;
  &:hover {
    background-color: rgba(224, 250, 255, 1);
    color: #166CB3 !important;
  }
  /* border: 1px solid rgba(0, 0, 0, 0.125); */
}
.bg-blue-lighter-toeic {
  background-color: #166CB3;
}
.drop {
  box-shadow: 0px 4px 4px 0px #166CB34D;
  border-radius: 6px;
  // border-bottom: 2px solid rgb(214, 224, 233);
}
</style>